class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    // refreshCartPage()
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");
    getSelectedVariant()
    estDeliveryDate();
    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = "";

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace(
        "[min]",
        event.target.dataset.min
      );
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace(
        "[max]",
        event.target.max
      );
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace(
        "[step]",
        event.target.step
      );
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
        estDeliveryDate()
        getSelectedVariant()
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").textContent =
        message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// accept alternative + offload confimration

document.addEventListener("DOMContentLoaded", function () {
  // refreshCartPage()
  const cartForm = document.querySelector('form[action="/cart"]');
  if (!cartForm) return;

  function setupRadioValidation(groupName, wrapperClass) {
    const wrapper = document.querySelector(`.${wrapperClass}`);
    if (!wrapper) return null;

    const radioButtons = wrapper.querySelectorAll(`input[name="${groupName}"]`);
    if (!radioButtons.length) return null;

    let errorSpan = wrapper.querySelector(".error-message");
    if (!errorSpan) {
      errorSpan = document.createElement("span");
      errorSpan.classList.add("error-message");
      errorSpan.style.color = "red";
      errorSpan.style.marginLeft = "10px";
      errorSpan.style.fontSize = "0.9em";
      errorSpan.textContent = "Please select an option";
      errorSpan.style.display = "none";

      const spans = wrapper.querySelectorAll("span");
      if (spans.length > 0) {
        spans[spans.length - 1].insertAdjacentElement("afterend", errorSpan);
      } else {
        wrapper.appendChild(errorSpan);
      }
    }

    return {
      validate: function () {
        const isSelected = Array.from(radioButtons).some((rb) => rb.checked);
        if (!isSelected) {
          errorSpan.style.display = "inline";
          wrapper.style.border = "2px solid red";
          wrapper.style.borderRadius = "5px";
          radioButtons[0].focus();
          return false;
        } else {
          errorSpan.style.display = "none";
          wrapper.style.border = "none";
          return true;
        }
      },
      getSelectedValue: function () {
        const selected = wrapper.querySelector(
          `input[name="${groupName}"]:checked`
        );
        return selected ? selected.value : null;
      },
      groupName: groupName,
    };
  }

  // Setup validation and attribute collection for each group
  const altValidation = setupRadioValidation(
    "attributes[accept_alt]",
    "accept_alt"
  );
  const offloadValidation = setupRadioValidation(
    "attributes[offload_confirmation]",
    "offload_confirmation"
  );

  cartForm.addEventListener("submit", function (e) {
    let isFormValid = true;

    if (altValidation && !altValidation.validate()) isFormValid = false;
    if (offloadValidation && !offloadValidation.validate()) isFormValid = false;

    if (!isFormValid) {
      e.preventDefault();
      return;
    }

    // Remove existing attribute inputs to avoid duplicates
    const existingInputs = cartForm.querySelectorAll(
      'input[name^="attributes["]'
    );
    existingInputs.forEach((input) => input.remove());

    // Add selected values as hidden inputs
    [altValidation, offloadValidation].forEach((validationObj) => {
      if (validationObj) {
        const val = validationObj.getSelectedValue();
        if (val) {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = validationObj.groupName; // already has attributes[...] format
          input.value = val;
          cartForm.appendChild(input);
        }
      }
    });
  });

  // Fast Checkout compatiblity (no validation)
function getSelectedValue(groupName) {
  const input = document.querySelector(`input[name="${groupName}"]:checked`);
  return input ? input.value : null;
}

function updateCartAttributes(attributes) {
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ attributes })
  });
}

function handleFastCheckoutClick(event) {
  const acceptAlt = getSelectedValue('attributes[accept_alt]');
  const offloadConf = getSelectedValue('attributes[offload_confirmation]');

  const attrs = {};
  if (acceptAlt) attrs['accept_alt'] = acceptAlt;
  if (offloadConf) attrs['offload_confirmation'] = offloadConf;

  if (Object.keys(attrs).length === 0) return; // nothing to save

  event.preventDefault(); // try to delay the fast checkout

  updateCartAttributes(attrs).finally(() => {
    event.target.click(); // re-trigger the original button after update
  });
}

function observeFastCheckoutButtons() {
  const alreadyHandled = new WeakSet();

  const tryAttachHandlers = () => {
    const buttons = document.querySelectorAll(
      '[data-shopify-button="shop-pay-button"], .shopify-payment-button__button, #dynamic-checkout-cart button'
    );

    buttons.forEach(button => {
      if (!alreadyHandled.has(button)) {
        alreadyHandled.add(button);
        button.addEventListener('click', handleFastCheckoutClick, { once: true });
      }
    });
  };

  tryAttachHandlers();

  // Watch for dynamic changes (e.g. fast checkout button appears later)
  const observer = new MutationObserver(() => {
    tryAttachHandlers();
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

observeFastCheckoutButtons();
});

// Auto Shipping protection 
var selectvariant;
function isShopPayRedirectEnabled() {
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    const shopPayCookie = cookies.find(cookie => cookie.startsWith('shopify_pay_redirect='));
    if (shopPayCookie) {
      const cookieValue = shopPayCookie.split('=')[1];
      return cookieValue === 'true';
    }
    return false;
}
isShopPayRedirectEnabled()
// $(document).on("click", ".cart__blocks .cart__ctas .cart__checkout-button:not(.cart__checkout-button-original)", function () {

//   const $btn = $(this);
//   if ($btn.hasClass("loading")) return;
//   $btn.addClass("loading");

//   function errHandler(xhr) {
//     const msg = xhr && xhr.responseText && xhr.responseText.includes("updates parameter is invalid")
//       ? "Your cart changed in another tab/window. Please refresh the page and try again."
//       : "Something went wrong updating the cart. Please refresh the page.";

//     alert(msg);
//     refreshCartPage();
//     $(".cart__checkout-button:not(.cart__checkout-button-original)").removeClass("loading");
//   }

//   try {
//     let href = $('.cart-item-group')
//       .find('.cart-item .cart-item__details-info .cart-item__name[href*="shipping-protection"]')
//       .attr("href");

//     let shipping_protection = href && href.includes("?variant=")
//       ? href.split("?variant=")[1]
//       : null;

//     if (!selectvariant) {
//       $(".cart__checkout-button.cart__checkout-button-original").trigger("click");
//       return;
//     }

//     // NORMAL CHECKOUT FLOW
//     if (!isShopPayRedirectEnabled()) {

//       // ADD NEW
//       if (!shipping_protection && selectvariant) {
//         $.ajax({
//           type: "POST",
//           url: "/cart/add.js",
//           data: { quantity: 1, id: selectvariant },
//           dataType: "json"
//         })
//           .done(function () {
//             $(".cart__checkout-button.cart__checkout-button-original").trigger("click");
//           })
//           .fail(errHandler);
//         return;
//       }

//       // UPDATE (remove + add)
//       if (shipping_protection !== selectvariant && shipping_protection) {
//         $.ajax({
//           type: "POST",
//           url: "/cart/change.js",
//           data: { quantity: 0, id: shipping_protection },
//           dataType: "json"
//         })
//           .done(function () {
//             $.ajax({
//               type: "POST",
//               url: "/cart/add.js",
//               data: { quantity: 1, id: selectvariant },
//               dataType: "json"
//             })
//               .done(function () {
//                 $(".cart__checkout-button.cart__checkout-button-original").trigger("click");
//               })
//               .fail(errHandler);
//           })
//           .fail(errHandler);
//         return;
//       }

//       $(".cart__checkout-button.cart__checkout-button-original").trigger("click");
//       return;
//     }

//     // SHOP PAY FLOW
//     if (shipping_protection !== selectvariant && shipping_protection) {
//       $.ajax({
//         type: "POST",
//         url: "/cart/change.js",
//         data: { quantity: 0, id: shipping_protection },
//         dataType: "json"
//       })
//         .done(function () {
//           $(".cart__checkout-button.cart__checkout-button-original").trigger("click");
//         })
//         .fail(errHandler);
//       return;
//     }

//     $(".cart__checkout-button.cart__checkout-button-original").trigger("click");

//   } catch (e) {
//     alert("Something went wrong. Please refresh the page and try again.");
//     refreshCartPage();
//     $(".cart__checkout-button:not(.cart__checkout-button-original)").removeClass("loading");
//   }
// });

$(document).on('click', '.cart__blocks .cart__ctas .cart__checkout-button:not(.cart__checkout-button-original)', function (e) {
    e.preventDefault();
    e.stopPropagation();
    
    var $button = $(this);
    
    // Prevent multiple simultaneous clicks
    if ($button.hasClass('loading') || $button.hasClass('processing')) {
        return false;
    }
    
    $button.addClass('loading').addClass('processing');
    
    // Validate selectvariant before proceeding
    if (typeof selectvariant === 'undefined' || !selectvariant) {
        console.warn('selectvariant is not defined, proceeding with original checkout');
        $button.removeClass('loading').removeClass('processing');
        proceedToCheckout();
        return false;
    }
    
    // Fetch current cart data from API
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        timeout: 10000,
        success: function(cart) {
            console.log('cart', cart);
            
            // Validate cart response
            if (!cart || !cart.items) {
                console.error('Invalid cart response');
                $button.removeClass('loading').removeClass('processing');
                proceedToCheckout();
                return;
            }
            
            // Find shipping protection item by product_title
            var shippingProtectionItem = cart.items.find(function(item) {
                return item.product_title === 'Shipping Protection';
            });
            
            var shipping_protection = shippingProtectionItem ? shippingProtectionItem.variant_id.toString() : null;
            var selectvariantStr = selectvariant.toString();
            
            // Check if shipping protection is different from selected variant or if it doesn't exist
            if (!isShopPayRedirectEnabled()) {
                // Case 1: No shipping protection in cart, but user selected one
                if (!shipping_protection && selectvariantStr) {
                    console.log('add new shipping protection');
                    addShippingProtection(selectvariantStr, function() {
                        $button.removeClass('loading').removeClass('processing');
                        setTimeout(function() {
                            proceedToCheckout();
                        }, 500);
                    }, function(error) {
                        console.error('Failed to add shipping protection:', error);
                        $button.removeClass('loading').removeClass('processing');
                        proceedToCheckout();
                    });
                }
                // Case 2: Different shipping protection in cart, need to replace
                else if (shipping_protection && selectvariantStr && shipping_protection !== selectvariantStr) {
                    console.log('replace shipping protection', shipping_protection, 'with', selectvariantStr);
                    replaceShippingProtection(shipping_protection, selectvariantStr, function() {
                        $button.removeClass('loading').removeClass('processing');
                        setTimeout(function() {
                            proceedToCheckout();
                        }, 500);
                    }, function(error) {
                        console.error('Failed to replace shipping protection:', error);
                        $button.removeClass('loading').removeClass('processing');
                        proceedToCheckout();
                    });
                }
                // Case 3: Shipping protection matches or no change needed
                else {
                    console.log('shipping protection already correct or no change needed');
                    $button.removeClass('loading').removeClass('processing');
                    proceedToCheckout();
                }
            } else {
                // ShopPay redirect enabled - only remove if different
                if (shipping_protection && selectvariantStr && shipping_protection !== selectvariantStr) {
                    console.log('remove shipping protection for ShopPay');
                    removeShippingProtection(shipping_protection, function() {
                        $button.removeClass('loading').removeClass('processing');
                        setTimeout(function() {
                            proceedToCheckout();
                        }, 500);
                    }, function(error) {
                        console.error('Failed to remove shipping protection:', error);
                        $button.removeClass('loading').removeClass('processing');
                        proceedToCheckout();
                    });
                } else {
                    $button.removeClass('loading').removeClass('processing');
                    proceedToCheckout();
                }
            }
        },
        error: function(xhr, status, error) {
            console.error('Failed to fetch cart:', status, error);
            $button.removeClass('loading').removeClass('processing');
            
            // Fallback to original DOM method if API fails
            var shipping_protection = null;
            var $shippingProtectionLink = $('.cart-item-group').find('.cart-item .cart-item__details-info .cart-item__name[href*="shipping-protection"]');
            
            if ($shippingProtectionLink.length) {
                var href = $shippingProtectionLink.attr('href');
                if (href) {
                    var variantMatch = href.match(/[?&]variant=([^&]+)/);
                    if (variantMatch) {
                        shipping_protection = variantMatch[1];
                    }
                }
            }
            
            // Validate selectvariant before proceeding with fallback
            if (typeof selectvariant === 'undefined' || !selectvariant) {
                proceedToCheckout();
                return;
            }
            
            var selectvariantStr = selectvariant.toString();
            
            // Continue with existing logic but with better error handling
            if (!isShopPayRedirectEnabled()) {
                if (!shipping_protection && selectvariantStr) {
                    console.log('add new (fallback)');
                    addShippingProtection(selectvariantStr, function() {
                        setTimeout(function() {
                            proceedToCheckout();
                        }, 500);
                    }, function() {
                        proceedToCheckout();
                    });
                } else if (shipping_protection && selectvariantStr && shipping_protection !== selectvariantStr) {
                    console.log('replace shipping protection (fallback)', shipping_protection);
                    replaceShippingProtection(shipping_protection, selectvariantStr, function() {
                        setTimeout(function() {
                            proceedToCheckout();
                        }, 500);
                    }, function() {
                        proceedToCheckout();
                    });
                } else {
                    proceedToCheckout();
                }
            } else {
                if (shipping_protection && selectvariantStr && shipping_protection !== selectvariantStr) {
                    removeShippingProtection(shipping_protection, function() {
                        setTimeout(function() {
                            proceedToCheckout();
                        }, 250);
                    }, function() {
                        proceedToCheckout();
                    });
                } else {
                    proceedToCheckout();
                }
            }
        }
    });
    
    return false;
});

// ============================================
// CRITICAL: Direct redirect to checkout
// ============================================
function proceedToCheckout() {
    // Clean update parameters first (safety measure)
    cleanAllUpdateParameters();
    sessionStorage.setItem('cart_checkout_navigation', 'true');

    // Direct redirect to checkout - this avoids form submission issues
    console.log('Redirecting to checkout...');
    window.location.href = '/checkout';
}

// Clean all update parameters from forms
function cleanAllUpdateParameters() {
    console.log('Cleaning all update parameters from forms...');
    
    // Find all forms on the page
    $('form').each(function() {
        var $form = $(this);
        var formAction = $form.attr('action') || '';
        
        // Only clean forms that submit to /cart (not /cart/add.js or /cart/change.js)
        if (formAction === '/cart' || (formAction.includes('/cart') && !formAction.includes('.js'))) {
            // Remove all inputs with 'updates' in the name
            $form.find('input[name*="updates"]').remove();
            $form.find('input[name*="update"]').remove();
            $form.find('input[name="updates"]').remove();
            $form.find('input[name="update"]').remove();
            
            // Remove hidden inputs that might contain update data
            $form.find('input[type="hidden"]').each(function() {
                var $input = $(this);
                var name = $input.attr('name') || '';
                var id = $input.attr('id') || '';
                
                // Remove if name or id contains 'update'
                if (name.toLowerCase().includes('update') || id.toLowerCase().includes('update')) {
                    console.log('Removing update parameter:', name || id);
                    $input.remove();
                }
            });
        }
    });
}

// Helper function to add shipping protection
function addShippingProtection(variantId, successCallback, errorCallback) {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: 1,
            id: variantId
        },
        dataType: 'json',
        timeout: 10000,
        success: function(response) {
            console.log('Successfully added shipping protection:', response);
            if (successCallback) successCallback(response);
        },
        error: function(xhr, status, error) {
            console.error('Error adding shipping protection:', xhr.responseJSON || error);
            if (errorCallback) errorCallback(xhr.responseJSON || error);
        }
    });
}

// Helper function to remove shipping protection
function removeShippingProtection(variantId, successCallback, errorCallback) {
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
            quantity: 0,
            id: variantId
        },
        dataType: 'json',
        timeout: 10000,
        success: function(response) {
            console.log('Successfully removed shipping protection:', response);
            if (successCallback) successCallback(response);
        },
        error: function(xhr, status, error) {
            console.error('Error removing shipping protection:', xhr.responseJSON || error);
            // If item doesn't exist, consider it a success (already removed)
            if (xhr.status === 422) {
                var errorMsg = xhr.responseJSON ? JSON.stringify(xhr.responseJSON) : '';
                if (errorMsg.includes('updates parameter is invalid') || 
                    errorMsg.includes('not found') ||
                    errorMsg.includes('does not exist')) {
                    console.log('Item may not exist in cart, treating as success');
                    if (successCallback) successCallback({});
                } else {
                    if (errorCallback) errorCallback(xhr.responseJSON || error);
                }
            } else {
                if (errorCallback) errorCallback(xhr.responseJSON || error);
            }
        }
    });
}

// Helper function to replace shipping protection
function replaceShippingProtection(oldVariantId, newVariantId, successCallback, errorCallback) {
    removeShippingProtection(oldVariantId, function() {
        addShippingProtection(newVariantId, function() {
            if (successCallback) successCallback();
        }, function(error) {
            if (errorCallback) errorCallback(error);
        });
    }, function(error) {
        console.log('Removal failed, but attempting to add new variant');
        addShippingProtection(newVariantId, function() {
            if (successCallback) successCallback();
        }, function(addError) {
            if (errorCallback) errorCallback(addError);
        });
    });
}

// ============================================
// SAFETY NET: Intercept form submissions to /cart
// ============================================
// This prevents the 422 error if user clicks original checkout button
$(document).on('submit', 'form[action="/cart"], form[action*="/cart"]', function(e) {
    var $form = $(this);
    var formAction = $form.attr('action') || '';
    
    // Only intercept if going to /cart (not /cart/add.js or /cart/change.js)
    if (formAction === '/cart' || (formAction.includes('/cart') && !formAction.includes('.js'))) {
        console.log('Intercepting cart form submission, redirecting to checkout instead...');
        
        // Prevent form submission
        e.preventDefault();
        e.stopPropagation();
        
        // Clean update parameters
        cleanAllUpdateParameters();
        
        // Redirect to checkout instead
        window.location.href = '/checkout';
        return false;
    }
});

function getSelectedVariant() {
  var Total_Price = $('.cart__footer').find('.totals').find('.totals__total-value').text()
  var Subtotal = Total_Price;
  if ($('.cart-item-group').find('.cart-item .cart-item__details-info .cart-item__name[href*="shipping-protection"]').length) {
    var shipping_protection_items = [];
    shipping_protection_items.push(parseFloat($('.cart-items').find('.cart-item.shipping_protection').find('.cart-item__price-wrapper .price').text().replace('$', '').replace(',', '')))
    var shipping_protect = shipping_protection_items.reduce((partialSum, a) => partialSum + a, 0);
    Subtotal = parseFloat((parseFloat(Total_Price.replace('$', '').replace(',', '')) - shipping_protect).toFixed(2));
  } else {
    Subtotal = parseFloat(Subtotal.replace('$', '').replace(',', ''));
  }

  var TotalPercantage = (Subtotal) !== "undefined" ? ((Subtotal) * .03).toFixed(2) : "";
  var SP_prices_Array = [0.98, 1.15, 1.35, 1.55, 1.75, 1.95, 2.15, 2.35, 2.55, 2.75, 2.95, 3.15, 3.35, 3.55, 3.75, 3.95, 4.15, 4.35, 4.55, 4.75, 4.95, 5.15, 5.35, 5.55, 5.75, 5.95, 6.15, 6.35, 6.55, 6.75, 6.95, 7.15, 7.35, 7.55, 7.75, 7.95, 8.15, 8.35, 8.55, 8.75, 8.95, 9.38, 10.03, 10.68, 11.33, 11.98, 12.63, 13.28, 13.93, 14.58, 15.23, 15.88, 16.53, 17.18, 17.83, 18.48, 19.13, 19.78, 20.43, 24.38, 31.63, 38.88, 46.13, 53.38, 60.63, 67.88, 75.13, 82.38, 89.63, 96.88, 104.13, 111.38, 118.63, 125.88, 133.13, 140.38, 147.63, 154.88, 162.13, 169.38, 176.63, 186.78, 196.93, 207.08, 217.23, 227.38, 237.53, 247.68, 257.83, 267.98, 278.13, 292.08, 306.03, 319.98, 333.93, 347.88, 361.83, 375.78, 389.73, 403.68];
  var SP_Variant_Array = ["39358028185649-0.98", "39358028218417-1.15", "39358028251185-1.35", "39358028283953-1.55", "39358028316721-1.75", "39358028349489-1.95", "39358028382257-2.15", "39358028415025-2.35", "39358028447793-2.55", "39358028480561-2.75", "39358028513329-2.95", "39358028546097-3.15", "39358028578865-3.35", "39358028611633-3.55", "39358028644401-3.75", "39358028677169-3.95", "39358028709937-4.15", "39358028742705-4.35", "39358028775473-4.55", "39358028808241-4.75", "39358028841009-4.95", "39358028873777-5.15", "39358028906545-5.35", "39358028939313-5.55", "39358028972081-5.75", "39358029004849-5.95", "39358029037617-6.15", "39358029070385-6.35", "39358029103153-6.55", "39358029135921-6.75", "39358029168689-6.95", "39358029201457-7.15", "39358029234225-7.35", "39358029266993-7.55", "39358029299761-7.75", "39358029332529-7.95", "39358029365297-8.15", "39358029398065-8.35", "39358029430833-8.55", "39358029463601-8.75", "39358029496369-8.95", "39358029529137-9.38", "39358029561905-10.03", "39358029594673-10.68", "39358029627441-11.33", "39358029660209-11.98", "39358029692977-12.63", "39358029725745-13.28", "39358029758513-13.93", "39358029791281-14.58", "39358029824049-15.23", "39358029856817-15.88", "39358029889585-16.53", "39358029922353-17.18", "39358029955121-17.83", "39358029987889-18.48", "39358030020657-19.13", "39358030053425-19.78", "39358030086193-20.43", "39358030118961-24.38", "39358030151729-31.63", "39358030184497-38.88", "39358030217265-46.13", "39358030250033-53.38", "39358030282801-60.63", "39358030315569-67.88", "39358030348337-75.13", "39358030381105-82.38", "39358030413873-89.63", "39358030446641-96.88", "39358030479409-104.13", "39358030512177-111.38", "39358030544945-118.63", "39358030577713-125.88", "39358030610481-133.13", "39358030643249-140.38", "39430907166769-147.63", "39430907199537-154.88", "39430907330609-162.13", "39430907363377-169.38", "39430907396145-176.63", "39430907428913-186.78", "39430907494449-196.93", "39430907527217-207.08", "39430907559985-217.23", "39430907592753-227.38", "39430907625521-237.53", "39430907658289-247.68", "39430907691057-257.83", "39430907756593-267.98", "39430907822129-278.13", "39430907854897-292.08", "39430907887665-306.03", "39430907920433-319.98", "39430907985969-333.93", "39430908051505-347.88", "39430908149809-361.83", "39430908215345-375.78", "39430908313649-389.73", "39430908379185-403.68"];
  var selectvariantIndex;
  var closestNumber;
  if (TotalPercantage !== "undefined") {
    closestNumber = SP_prices_Array.reduce((a, b) => {
      return Math.abs(b - TotalPercantage) < Math.abs(a - TotalPercantage) ? b : a;
    });
    for (var i = 0; i < SP_Variant_Array.length; i++) {
      if (SP_Variant_Array[i].includes('-' + closestNumber)) {
        selectvariantIndex = SP_Variant_Array[i];
        selectvariant = SP_Variant_Array[i].split('-')[0];
      }
    }
  }
}

// disable scroll wheel from altering numerical input values
document.addEventListener('wheel', function(e) {
  if (document.activeElement.type === 'number') {
    document.activeElement.blur();
  }
}, { passive: false });


// ============================================
// Refresh cart when returning from checkout via browser back button
// ============================================

// Method 1: Use pageshow event to detect back/forward navigation
$(window).on('pageshow', function(event) {
    // Check if page was loaded from cache (back/forward button)
    if (event.originalEvent.persisted || (performance && performance.navigation && performance.navigation.type === 2)) {
        console.log('Page loaded from cache (back/forward navigation), refreshing cart...');
        refreshCartDisplay();
    }
});

// Method 2: Use visibility API to detect when page becomes visible
document.addEventListener('visibilitychange', function() {
    if (!document.hidden) {
        // Page became visible, check if we need to refresh
        if (window.location.pathname.includes('/cart') || window.location.pathname === '/cart') {
            // Check if we have a referrer from checkout
            if (document.referrer && document.referrer.includes('/checkout')) {
                console.log('Returned to cart from checkout, refreshing cart...');
                refreshCartDisplay();
            }
        }
    }
});

// Method 3: Use sessionStorage to track navigation
// Set flag when going to checkout
$(document).on('click', '.cart__blocks .cart__ctas .cart__checkout-button:not(.cart__checkout-button-original)', function() {
    sessionStorage.setItem('cart_checkout_navigation', 'true');
});

// Also set flag in your proceedToCheckout function
// Add this line at the start of proceedToCheckout():
// sessionStorage.setItem('cart_checkout_navigation', 'true');

// Check flag on page load
$(document).ready(function() {
    // Check sessionStorage first
    if (sessionStorage.getItem('cart_checkout_navigation') === 'true') {
        sessionStorage.removeItem('cart_checkout_navigation');
        console.log('Detected navigation from checkout, refreshing cart...');
        setTimeout(function() {
            refreshCartDisplay();
        }, 100);
    }
    // Also check referrer
    else if (document.referrer && document.referrer.includes('/checkout')) {
        console.log('Page loaded with checkout as referrer, refreshing cart...');
        setTimeout(function() {
            refreshCartDisplay();
        }, 100);
    }
});

// ============================================
// Function to refresh cart display
// ============================================
function refreshCartDisplay() {
    console.log('Refreshing cart display...');
    
    // Show loading indicator if exists
    var $cartContainer = $('.cart, .cart-page, [data-cart-container]').first();
    if ($cartContainer.length) {
        $cartContainer.addClass('cart-loading');
    }
    
    // Fetch latest cart data
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        timeout: 10000,
        success: function(cart) {
            console.log('Cart refreshed:', cart);
            
            // Update cart count
            updateCartCount(cart.item_count);
            
            // Trigger cart refresh events
            $(document).trigger('cart:refresh', [cart]);
            $(document).trigger('cart:updated', [cart]);
            
            // Reload cart items section
            reloadCartItems();
        },
        error: function(xhr, status, error) {
            console.error('Failed to refresh cart:', status, error);
            // Fallback: reload the page
            window.location.reload();
        }
    });
}

// ============================================
// Function to reload cart items
// ============================================
function reloadCartItems() {
    // Try to find cart items container
    var $cartItems = $('.cart-items, .cart__items, [data-cart-items], .cart__contents').first();
    var $cartForm = $('form[action="/cart"], form[action*="/cart"]').first();
    
    if ($cartItems.length || $cartForm.length) {
        // Fetch cart HTML
        $.ajax({
            type: 'GET',
            url: '/cart',
            success: function(html) {
                var $newCart = $(html);
                
                // Update cart items
                if ($cartItems.length) {
                    var $newCartItems = $newCart.find($cartItems[0].className.split(' ').map(c => '.' + c).join(''));
                    if ($newCartItems.length) {
                        $cartItems.html($newCartItems.html());
                    } else {
                        // Try common selectors
                        var $newItems = $newCart.find('.cart-items, .cart__items, [data-cart-items], .cart__contents');
                        if ($newItems.length) {
                            $cartItems.html($newItems.html());
                        }
                    }
                }
                
                // Update cart form if exists
                if ($cartForm.length) {
                    var $newCartForm = $newCart.find('form[action="/cart"], form[action*="/cart"]');
                    if ($newCartForm.length) {
                        $cartForm.replaceWith($newCartForm);
                    }
                }
                
                // Update totals
                var $cartTotals = $('.cart-totals, .cart__totals, [data-cart-totals], .cart__footer');
                if ($cartTotals.length) {
                    var $newTotals = $newCart.find('.cart-totals, .cart__totals, [data-cart-totals], .cart__footer');
                    if ($newTotals.length) {
                        $cartTotals.replaceWith($newTotals);
                    }
                }
                
                // Remove loading class
                $('.cart, .cart-page, [data-cart-container]').removeClass('cart-loading');
                
                // Reinitialize any cart-related scripts
                $(document).trigger('cart:itemsUpdated');
                $(document).trigger('cart:reloaded');
                
                console.log('Cart items updated');
            },
            error: function() {
                console.error('Failed to fetch cart HTML');
                $('.cart, .cart-page, [data-cart-container]').removeClass('cart-loading');
                // Fallback: reload the page
                window.location.reload();
            }
        });
    } else {
        // No cart container found, do a full reload
        console.log('No cart container found, doing full reload...');
        window.location.reload();
    }
}

// ============================================
// Helper function to update cart count
// ============================================
function updateCartCount(count) {
    // Update various cart count elements
    $('.cart-count, [data-cart-count], .cart__count, .header__cart-count').text(count);
    
    // Update cart count in header if exists
    if (typeof theme !== 'undefined' && theme.cartCount) {
        theme.cartCount = count;
    }
    
    // Trigger event
    $(document).trigger('cart:countUpdated', [count]);
}

// ============================================
// Update your proceedToCheckout function
// ============================================
// Add this line at the START of your proceedToCheckout() function:
// sessionStorage.setItem('cart_checkout_navigation', 'true');